export default __webpack_public_path__ + "a6d96f59d682043c1755d4fba3d01f1f.png";